import React from 'react';
import { useLocale } from '@platform/core';
import { MagicGrid } from '../components/MagicGrid';

export default function POVsPage() {
  const { t } = useLocale();

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>👁️ {t('planning.povs') || 'Points of View'}</h1>
        <p className="page-subtitle">
          {t('planning.povsDescription') || 'Manage points of view and perspectives'}
        </p>
      </div>
      <MagicGrid
        firestorePath="companies/{companyId}/POVs/content"
        editable
        addable
        deletable
      />
      <style>{pageStyles}</style>
    </div>
  );
}

const pageStyles = `
  .page-container { max-width: 1200px; margin: 0 auto; }
  .page-header { margin-bottom: 1.5rem; }
  .page-header h1 { margin: 0 0 0.25rem; font-size: 1.5rem; }
  .page-subtitle { color: var(--text-secondary, #757575); margin: 0; font-size: 0.875rem; }
  @media (max-width: 768px) {
    .page-container { max-width: 100%; padding: 0; }
    .page-header { margin-bottom: 0.75rem; }
    .page-header h1 { font-size: 1.25rem; }
  }
`;
